import { render } from "./TheCartOrderPay.vue?vue&type=template&id=55e92252"
import script from "./TheCartOrderPay.vue?vue&type=script&lang=js"
export * from "./TheCartOrderPay.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__